import { Typography } from 'antd';
import FileTextIconOutlined from 'components/icons/FileTextIconOutlined';
import ConfirmationModal from 'components/new-ui/composed/modal/confirmation-modal/ConfirmationModal';

type Props = {
    open: boolean;
    errorNotification: string;
    onClose: () => void;
    onConfirm: () => void;
};

const ErrorProcessingModal = ({ open, errorNotification, onClose, onConfirm }: Props) => {
    return (
        <ConfirmationModal
            maskClosable={false}
            confirmButtonText="Try Again"
            icon={<FileTextIconOutlined />}
            open={open}
            onCancel={onClose}
            onClose={onClose}
            onConfirm={onConfirm}
            title="Error processing"
            content={
                <div style={{ paddingInline: 16, marginTop: 8 }}>
                    <Typography>{errorNotification}</Typography>
                </div>
            }
        />
    );
};

export default ErrorProcessingModal;
